<template>
	<div
		v-intersect="{
			callback: () => (intersected = true),
		}"
		class="relative flex flex-col pb-60 pb-60 lg:-top-24 lg:-mb-32"
	>
		<div class="lg:bg-sectionBg bg-white lg:pt-12">
			<div class="container mx-auto max-w-screen-xl">
				<div
					class="relative mb-6 flex flex-col gap-9 px-4 lg:mb-8 lg:flex-row lg:justify-between lg:gap-5"
				>
					<div
						v-for="(item, index) in congratsTips"
						:key="index"
						class="relative flex-1 grow flex-col items-center justify-center rounded-xl bg-white px-6 py-8 lg:px-8 lg:pb-9 lg:pt-10 lg:shadow-lg"
					>
						<div
							class="align-center border-smallElementsColor absolute -top-8 left-1/2 flex h-8 w-8 -translate-x-1/2 justify-center rounded-full border-2 bg-white transition duration-1000 lg:-top-7 lg:h-14 lg:w-14"
							:class="{
								'translate-x-full opacity-0 lg:translate-x-0 lg:scale-75':
									!intersected,
								'delay-300 lg:delay-300': index === 0,
								'delay-500 lg:delay-500': index === 1,
								'delay-700 lg:delay-700': index === 2,
							}"
						>
							<p
								class="text-smallElementsColor lg:text-32 pt-0.5 text-base font-bold lg:pt-1"
							>
								{{ index + 1 }}
							</p>
						</div>

						<p class="text-primary text-center text-base lg:text-2xl">
							{{ item.text }}
						</p>
					</div>
				</div>
			</div>
		</div>

		<QuestionsSection class="lg:!bg-sectionBg" hide-phone />

		<div v-if="false" class="flex w-full flex-col items-center bg-white pt-8 lg:pt-12">
			<div class="container mx-auto max-w-5xl">
				<div class="mb-6 flex w-full lg:mb-10">
					<div
						v-for="tab in infoItems"
						:key="`${tab.id}-tab`"
						class="text-12 flex w-auto flex-1 cursor-pointer items-center justify-center px-2 py-1.5 text-center font-bold duration-300 ease-in-out lg:w-1/3 lg:py-6 lg:text-xl"
						:class="{
							'text-main-400 border-main-400 border-b-2 lg:border-b-4':
								activeTab === tab.id,
							'text-secondary border-b-2 border-gray-300 lg:border-b-4':
								activeTab !== tab.id,
						}"
						@click="onChangeTab(tab.id)"
					>
						{{ tab.tabName }}
					</div>
				</div>

				<div class="flex flex-col">
					<div
						v-for="item in infoItems[activeTab].tabItems"
						:key="`${item.id}-items`"
						class="box-border flex cursor-pointer flex-col py-3 pl-3 pr-2 lg:mb-2 lg:px-12 lg:py-4"
					>
						<div class="flex">
							<div class="mr-2 min-w-[20px] lg:mr-3 lg:max-h-[27px] lg:min-w-[27px]">
								<CheckSecondSvg class="fill-success-base h-5 w-5 lg:h-7 lg:w-7" />
							</div>

							<div class="flex flex-col">
								<div class="text-base lg:text-xl">
									{{ item.text }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import { ref, onMounted, computed } from 'vue'
	import CheckSecondSvg from '../components/icons/CheckSecondSvg.vue'
	import { useFormStore } from '../../../stores/form'
	import QuestionsSection from '../../common/QuestionsSection/QuestionsSection.vue'
	import { useConfigStore } from '../../../stores/config'

	// hooks
	const form = useFormStore()
	const config = useConfigStore()

	// refs
	const activeTab = ref(0)
	const intersected = ref(false)

	// lifecycle
	onMounted(() => {
		form.state = config.config.location.state || 'STATE:'
	})

	// constants
	const defaultCongratsTips = [
		{
			text: `We will appraise your :MAKE: based on the information you provided and will email and text your quote, valid for ${config.getQuoteValidityHumanize}.`,
		},
		{
			text: `Bring your :MAKE: in if you like your quote. We’ll verify the info you provided and make a final offer.`,
		},
		{
			text: 'Sell and get paid on the spot or trade in toward another car!',
		},
	]

	const infoItems = [
		{
			id: 0,
			tabName: 'What To Expect At Your Appointment',
			tabItems: [
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
			],
		},
		{
			id: 1,
			tabName: 'What To Bring',
			tabItems: [
				{
					id: 0,
					text: 'A 2 Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A 2 Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},

				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
			],
		},
		{
			id: 2,
			tabName: 'Appointment Tips',
			tabItems: [
				{
					id: 0,
					text: 'A 3 Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A 3 Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
				{
					id: 0,
					text: 'A Driveo team member will verify the information your provided, this includes a mechanical inspection and possibly a test drive.',
				},
			],
		},
	]

	// computed
	const congratsTips = computed(() => {
		return config
			.getConfigContent('congratsTips', defaultCongratsTips)
			.filter((_, index) => !!defaultCongratsTips[index])
			.map((benefit, index) => {
				return {
					text: (benefit.text || defaultCongratsTips[index].text).replace(
						':MAKE:',
						form.soldMake,
					),
				}
			})
	})

	const onChangeTab = (tab: number): void => {
		activeTab.value = tab
	}
</script>
